import React, { useEffect, useState, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";

import { refSagaActions } from "../../Administration/ReferenceInfoManagement";
import { serviceSagaActions } from "../../Administration/ServiceManagement";
import { serviceItemSagaActions } from "../../Administration/ServiceItemManagement";
import { provinceSagaActions } from "../../Administration/ProvinceInfoManagement";

import { Button, Form, Col, Card, Collapse } from "react-bootstrap";
import { CaretDownFill, CaretUpFill, Search, Calendar4Week } from "react-bootstrap-icons";
import ReactDatePicker from "react-datepicker";
import { Formik } from "formik";
import { format } from "date-fns";
import * as Yup from "yup";

import styles from "../css/ReceiptTrackingSearchForm.module.css";

const presentDate = new Date();
const formatPresentDate = format(presentDate, "dd-MMMM-yyyy");

//search form schema definition
const searchFormSchema = Yup.object().shape({
  prioritySearch: Yup.object({}),
  receiptNumber: Yup.string()
    .matches(/^[Ee]{1}[Rr]{1}[Gg]{1}[A-Za-z0-9]{10}$/, "*Invalid Receipt No.")
    .min(13, "*Incorrect length")
    .max(13, "*Incorrect length")
    .when('mobileNumber', {
      is: value => !value,
      then: Yup.string()
        .matches(/^[Ee]{1}[Rr]{1}[Gg]{1}[A-Za-z0-9]{10}$/, "*Invalid Receipt No.")
        .required("*Enter a Receipt No.")
        .min(13, "*Incorrect length")
        .max(13, "*Incorrect length"),
      otherwise: Yup.string()
    }),
  customerFirstName: Yup.string()
    .matches(/^[a-zA-Z'\s]{1,20}$/, "*Invalid character entered"),
  customerLastName: Yup.string()
    .matches(/^[a-zA-Z'\s]{1,20}$/, "*Invalid character entered"),
  mobileNumber: Yup.string()
    .matches(/^[6]{1}[7]{1}[5]{1}[78]{1}[0-9]{7}$/, "*Mobile No. format: 675xxxxxxxx")
    .when('receiptNumber', {
      is: value => !value,
      then: Yup.string().matches(/^[6]{1}[7]{1}[5]{1}[78]{1}[0-9]{7}$/, "*Mobile No. format: 675xxxxxxxx").required("*Enter a Mobile No."),
      otherwise: Yup.string()
    }),
  receiptStatus: Yup.string()
    .max(3, "*Invalid"),
  dept: Yup.string()
    .max(4, "*Invalid"),
  province: Yup.string()
  .max(3, "*Invalid"),
  serviceType: Yup.string()
    .max(3, "*Invalid"),
  fromIssuedDate: Yup.date()
    .max(presentDate, `Date must be earlier than the ${formatPresentDate}`),
  toIssuedDate: Yup.date()
    .min(Yup.ref('fromIssuedDate'), "*'Date To' must be after the 'Date From'")
    .max(presentDate, `Date must be earlier than the ${formatPresentDate}`)
}, ['receiptNumber', 'mobileNumber']);

export function ReceiptTrackingSearchForm(props) {
  const dispatch = useDispatch();
  const searchFormRef = useRef();

  const { reference, services, serviceItem, province, auth } = useSelector(state => state);  

  const { allReferences, referenceKinds } = reference;
  // const { agencies } = agency;
  const { serviceTypes } = services;
  const { serviceItems } = serviceItem;
  const { provinces } = province;
  const { user } = auth;

  const provAgencyId = user.prov_agency_id;
  let agencyId = services.serviceTypes.length > 0 ? services.serviceTypes[0].department_id : "";

  const [receiptStatuses, setReceiptStatuses] = useState([]);
  const [showSearch, setShowSearch] = useState(true);
  const [serviceItemList, setServiceItemList] = useState([]);

  useEffect(() => {

    dispatch(refSagaActions.fetchAllReferences());
    dispatch(refSagaActions.fetchReferenceKinds());
    dispatch(serviceSagaActions.fetchServices(provAgencyId));
    dispatch(serviceItemSagaActions.fetchServiceItems(provAgencyId));
    dispatch(provinceSagaActions.fetchProvinces({ id: provAgencyId.toString() }));
  }, [dispatch, provAgencyId]);

  useEffect(() => {
    if(referenceKinds.length > 1){
      let receiptStatusKind = referenceKinds.find((kind) => (kind.code === "RECEIPT_STATUS"));
      let recStats = allReferences.filter((ref) => (ref.kindId === receiptStatusKind.id && ref.description !== "Invalid"));
      setReceiptStatuses(recStats);
    }
  }, [referenceKinds, allReferences]);

  
  const handleSearchReceiptReset = () => {
    searchFormRef.current.reset();
    let today = format(presentDate, "dd/MM/yyyy");
    props.onHandleSearchReceipt({
      fromIssuedDate: today,
      toIssuedDate: today
    });
  };

  const handleSearchReceipt = (queryParams) => {
    
    props.onHandleSearchReceipt(queryParams);
  };

  const filterServiceItems = (serviceTypeId) => {
    let serviceItemList = serviceItems.filter((item) => (item.service_id === Number(serviceTypeId)));
    setServiceItemList(serviceItemList);
  };

  const queryParamsInitialState = {
    fromIssuedDate: "", 
    toIssuedDate: "", 
    receiptNumber: "", 
    receiptStatusId: "", 
    departmentId: agencyId,
    provAgencyId: provAgencyId, 
    serviceId: "",
    customerFirstName: "",
    customerLastName: "",
    mobileNumber: "",
    serviceItemId: "",
    provinceId: ""
  };

  return (
    <>
      <Card className={"rtSearchCard"}>
        <Card.Header>
          <span className="row">
            <span className="col d-flex align-items-center"> 
              <h4> <Search size={26} /> {" "} Search Reciept </h4> 
            </span>
            <span className="col">
              <span 
                className="p-0 m-0 d-flex justify-content-end"
              >
                { showSearch 
                  ? <Button variant="light" onClick={() => {setShowSearch(false)}} > <CaretUpFill size={15} /> </Button>
                  : <Button variant="light" onClick={() => {setShowSearch(true)}} > <CaretDownFill size={15} /> </Button>
                }
              </span>
            </span>
          </span>
        </Card.Header>
        <Collapse in={showSearch}>
          <Card.Body>
            <Formik
              initialValues={queryParamsInitialState}
              validationSchema={searchFormSchema}
              onSubmit={ (values, {setSubmitting}) => {
                setSubmitting(true);
                let newQueryParams = { 
                  fromIssuedDate: values.fromIssuedDate ? format(values.fromIssuedDate, "dd/MM/yyyy") : "", 
                  toIssuedDate: values.toIssuedDate ? format(values.toIssuedDate, "dd/MM/yyyy") : "", 
                  receiptNumber: values.receiptNumber, 
                  receiptStatusId: values.receiptStatusId, 
                  departmentId: agencyId, 
                  serviceId: values.serviceId,
                  customerFirstName: values.customerFirstName.trim(),
                  customerLastName: values.customerLastName.trim(),
                  mobileNumber: values.mobileNumber,
                  serviceItemId: values.serviceItemId,
                  provinceId: values.provinceId,
                  provAgencyId: provAgencyId,
                };
                handleSearchReceipt(newQueryParams);
                setSubmitting(false);
              }}
            >
              { ({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, handleReset, setFieldTouched, setFieldValue }) => (
                <Form ref={searchFormRef} onSubmit={handleSubmit}>
                <Form.Row>
                  <Col lg={3} md={12} sm={12}>
                    <Form.Group controlId="paramReceiptNumber">
                      <Form.Label>Receipt No. : <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        name="receiptNumber"
                        placeholder="ERGxxxxxxxxxx"
                        value={values.receiptNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.receiptNumber && errors.receiptNumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.receiptNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramMobileNumber">
                      <Form.Label>Customer Mobile No. : <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        name="mobileNumber"
                        placeholder="675xxxxxxxx" 
                        value={values.mobileNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.mobileNumber && errors.mobileNumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.mobileNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramCustomerFirstName">
                      <Form.Label>Customer First Name:</Form.Label>
                      <Form.Control
                        name="customerFirstName"
                        placeholder="First Name" 
                        value={values.customerFirstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.customerFirstName && errors.customerFirstName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.customerFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramCustomerLastName">
                      <Form.Label>Customer Last Name:</Form.Label>
                      <Form.Control
                        name="customerLastName"
                        placeholder="Last Name" 
                        value={values.customerLastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.customerLastName && errors.customerLastName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.customerLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramReceiptStatus">
                      <Form.Label>Receipt Status:</Form.Label>
                      <Form.Control
                        as="select"
                        name="receiptStatusId"
                        value={values.receiptStatusId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.receiptStatusId && errors.receiptStatusId}
                      >
                        <option value="">-- Select --</option>
                        {receiptStatuses.map((s, index) => (
                          <option key={index} value={s.id}>
                            {s.description}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.receiptStatusId}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramServiceType">
                      <Form.Label>Service Type:</Form.Label>
                      <Form.Control
                        as="select"
                        name="serviceId"
                        value={values.serviceId}
                        onChange={(e) => {handleChange(e); filterServiceItems(e.target.value); setFieldValue("serviceItemId", ""); }}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.serviceId && errors.serviceId}
                      >
                        <option value="">-- Select --</option>

                        {serviceTypes.map((type, index) => (
                          <option key={index} value={type.id}>
                            {type.description}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback>
                        {errors.serviceId}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramServiceItem">
                      <Form.Label>Service Item:</Form.Label>
                      <Form.Control
                        as="select"
                        name="serviceItemId"
                        value={values.serviceItemId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.serviceItemId && errors.serviceItemId}
                        disabled={ (values.serviceId === undefined || values.serviceId === "" || values.serviceId === null) }
                      >
                        <option value="">-- Select --</option>

                        {serviceItemList.map((type, index) => (
                          <option key={index} value={type.id}>
                            {type.description}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.serviceItemId}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col lg={4} md={12} sm={12}>
                    <Form.Group controlId="paramDepartment">
                      <Form.Label>Province:</Form.Label>
                      <Form.Control
                        as="select"
                        name="provinceId"
                        value={values.provinceId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={styles.formInput}
                        isInvalid={touched.provinceId && errors.provinceId}
                      >
                        <option value="">-- Select --</option>
                        {provinces.map((prov, index) => (
                          <option key={index} value={prov.id}>
                            {prov.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.provinceId}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={4} md={12} sm={12}>
                    <Form.Group controlId="paramFromDate">
                    <Form.Label> <Calendar4Week size={15} /> {" "} From:</Form.Label>
                      <ReactDatePicker
                        autoComplete="off"
                        className={touched.fromIssuedDate && errors.fromIssuedDate ? "form-control border border-danger" : "form-control"}
                        name="fromIssuedDate"
                        dateFormat="dd-MMMM-yyyy"
                        dateFormatCalendar="MMMM yyyy"
                        placeholderText={formatPresentDate}
                        selected={values.fromIssuedDate}
                        value={values.fromIssuedDate}
                        onChange={ (dt) => {
                          setFieldTouched("fromIssuedDate", true, true);
                          let date = dt;
                          if(date === null || date === undefined){
                            date = ""
                          }
                          let changes = { target: { name: "fromIssuedDate", value: date } };
                          handleChange(changes);  
                        }}
                        onBlur={handleBlur}
                        showMonthYearDropdown
                        scrollableMonthYearDropdown
                        minDate={new Date("06/01/2021")}
                        maxDate={presentDate}
                        todayButton="Today"
                        
                      />
                      { touched.fromIssuedDate && errors.fromIssuedDate ? <div style={{ color: "#F64E60" }}> {errors.fromIssuedDate} </div> : null }
                    </Form.Group>
                  </Col>
                  <Col lg={4} md={12} sm={12}>
                    <Form.Group controlId="paramToDate">
                      <Form.Label> <Calendar4Week size={15} /> {" "} To:</Form.Label>
                      <ReactDatePicker
                        autoComplete="off"
                        className={touched.toIssuedDate && errors.toIssuedDate ? "form-control border border-danger" : "form-control"}
                        name="toIssuedDate"
                        dateFormat="dd-MMMM-yyyy"
                        dateFormatCalendar="MMMM yyyy"
                        placeholderText={formatPresentDate}
                        selected={values.toIssuedDate}
                        value={values.toIssuedDate}
                        onChange={ (dt) => {
                          setFieldTouched("toIssuedDate", true, true);
                          let date = dt;
                          if(date === null || date === undefined){
                            date = ""
                          }
                          let changes = { target: { name: "toIssuedDate", value: date } };
                          handleChange(changes);  
                        }}
                        onBlur={handleBlur}
                        showMonthYearDropdown
                        scrollableMonthYearDropdown
                        minDate={new Date("06/01/2021")}
                        maxDate={presentDate}
                        todayButton="Today"
                      />
                      { touched.toIssuedDate && errors.toIssuedDate ? <div style={{ color: "#F64E60" }}> {errors.toIssuedDate} </div> : null }
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Button type="submit" variant="primary" disabled={isSubmitting}>
                  <Search size={15} /> {" "} Search
                </Button>{" "}
                <Button onClick={() => {handleSearchReceiptReset(); handleReset();}} variant="secondary">
                  Reset
                </Button>
              </Form>
            )}
            </Formik>
            
          </Card.Body>
        </Collapse>
      </Card>
    </>
  );
}
